// Хичээлийн дүрс — TAS брэндийн 4 өнгө (ягаан #5c1090, цэнхэр-ногоон #00bcd4, шар #f2cd30, улбар шар #f97316):
// цайвар дэвсгэр дээр тухайн өнгийн бараан хувилбар (уншигдахуйц). Нэрээр нь таана; танихгүй бол ном.
import React from "react";

const C = {
  purple: ["#f3eeff", "#5c1090"], teal: ["#e0f7fa", "#0e7490"],
  yellow: ["#fff6d6", "#8a6d00"], orange: ["#fff1e6", "#c2410c"],
};
const P = {
  math: <><path d="M7 6h10l-6 6 6 6H7" /></>,
  physics: <><circle cx="12" cy="12" r="1.6" /><ellipse cx="12" cy="12" rx="9" ry="3.6" /><ellipse cx="12" cy="12" rx="9" ry="3.6" transform="rotate(60 12 12)" /><ellipse cx="12" cy="12" rx="9" ry="3.6" transform="rotate(-60 12 12)" /></>,
  chem: <><path d="M9 3h6M10 3v6L5 19a1.5 1.5 0 0 0 1.3 2h11.4A1.5 1.5 0 0 0 19 19l-5-10V3" /><path d="M7.5 15h9" /></>,
  bio: <><path d="M5 19c0-8 5-14 14-14 0 9-6 14-14 14z" /><path d="M5 19l8-8" /></>,
  geo: <><circle cx="12" cy="12" r="9" /><path d="M3 12h18M12 3c3 3 3 15 0 18M12 3c-3 3-3 15 0 18" /></>,
  it: <><path d="M8 8l-4 4 4 4M16 8l4 4-4 4M14 5l-4 14" /></>,
  mongol: <><path d="M4 20l4-1 11-11-3-3L5 16z" /><path d="M14 6l3 3" /></>,
  script: <><path d="M12 3c-2 3 2 5 0 8s2 5 0 8" /><path d="M9 7h2M13 11h2M9 15h2" /></>,
  lit: <><path d="M2 5h6a4 4 0 0 1 4 4v11a3 3 0 0 0-3-3H2zM22 5h-6a4 4 0 0 0-4 4v11a3 3 0 0 1 3-3h7z" /></>,
  english: <><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" /><path d="M8 8h8M8 12h5" /></>,
  history: <><path d="M6 3h12M6 21h12M7 3c0 5 10 6 10 9s-10 4-10 9M17 3c0 5-10 6-10 9" /></>,
  social: <><circle cx="9" cy="8" r="3" /><path d="M3 20v-1a6 6 0 0 1 12 0v1" /><circle cx="17" cy="9" r="2.4" /><path d="M16 14a5 5 0 0 1 5 5v1" /></>,
  life: <><path d="M20.8 5.6a5.5 5.5 0 0 0-7.8 0L12 6.7l-1-1.1a5.5 5.5 0 0 0-7.8 7.8L12 22l8.8-8.6a5.5 5.5 0 0 0 0-7.8z" /></>,
  pe: <><circle cx="14" cy="4.5" r="2" /><path d="M7 21l3-6 3 2v5M13 17l-2-6 4-2 3 3h3M10 11l-3 1-2 3" /></>,
  book: <><path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20V3H6.5A2.5 2.5 0 0 0 4 5.5z" /><path d="M8 7h8" /></>,
};
const RULES = [
  [/матем/i, "math", "purple"], [/физик/i, "physics", "teal"], [/хими/i, "chem", "orange"], [/биолог/i, "bio", "teal"],
  [/газар/i, "geo", "teal"], [/мэдээлэл|ict|програм/i, "it", "purple"], [/монгол бичиг/i, "script", "yellow"],
  [/монгол хэл|эх хэл/i, "mongol", "purple"], [/уран зохиол|зохиол/i, "lit", "yellow"], [/англи|english/i, "english", "orange"],
  [/түүх/i, "history", "yellow"], [/нийгэм/i, "social", "orange"], [/амьдрах|сэтгэл/i, "life", "purple"], [/биеийн тамир|тамир/i, "pe", "orange"],
];

export default function SubjectIcon({ name, size = 44 }) {
  const r = RULES.find(([re]) => re.test(String(name || ""))) || [null, "book", "purple"];
  const [bg, fg] = C[r[2]];
  return (
    <span className="inline-flex items-center justify-center rounded-xl shrink-0" style={{ width: size, height: size, background: bg }} aria-hidden="true">
      <svg viewBox="0 0 24 24" width={size * 0.52} height={size * 0.52} fill="none" stroke={fg} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">{P[r[1]]}</svg>
    </span>
  );
}
